import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught a render error:", error, info.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 48, textAlign: "center", fontFamily: "sans-serif" }}>
          <h2 style={{ color: "#c0392b" }}>Something went wrong</h2>
          <p style={{ color: "#555", marginBottom: 8 }}>
            {this.state.error?.message || "An unexpected error occurred."}
          </p>
          <p style={{ color: "#888", fontSize: 13, marginBottom: 24 }}>
            Check the browser console for details.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "8px 20px",
              background: "#6a0dad",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
              fontSize: 14,
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
